import { Backdrop, Box, LinearProgress, Skeleton, Typography } from '@mui/material';
import React from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Styles from './ContainerLoader.module.scss';
import { useState, useEffect } from 'react';

function ContainerLoader({ loadingContainerStart, progress, containerHints }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loadedImages, setLoadedImages] = useState({});
    const gifUrl = process.env.REACT_APP_GLOBAL_MEDIA_URL;

    const data = containerHints || [];
    const currentSlide = data[currentIndex];

    const handleForward = () => {
        setCurrentIndex((prev) => (prev + 1) % data.length);
    };

    const handleBackward = () => {
        setCurrentIndex((prev) => (prev - 1 + data.length) % data.length);
    };

    useEffect(() => {
        if (!data?.length || data.length <= 1) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % data.length);
        }, 10000);

        return () => clearInterval(interval);
    }, [data]);

    return (
        <Backdrop
            open={loadingContainerStart}
            sx={{
                color: '#fff',
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
        >
            {data.length > 1 && (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <KeyboardArrowLeftIcon
                        onClick={handleBackward}
                        fontSize="large"
                        sx={{ fontSize: '40px', cursor: 'pointer', color: 'rgb(0,0,0)' }}
                    />
                </Box>
            )}

            <Box id="loadingAnimations" className={Styles.loadingAnimations}>
                {data.length > 1 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mt: 2 }}>
                        {data.map((_, index) => (
                            <Box
                                key={index}
                                sx={{
                                    width: 7,
                                    height: 7,
                                    borderRadius: '50%',
                                    backgroundColor: currentIndex === index ? '#282828' : '#bdbdbd',
                                    transition: '0.3s',
                                }}
                            />
                        ))}
                    </Box>
                )}
                {currentSlide?.imageUrl && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '35vw',
                            height: '40vh',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            boxShadow: '-4px 0 6px -4px rgb(168 162 162), 0 4px 6px -4px rgb(168 162 162), 0 -4px 6px -4px rgb(168 162 162)'
                        }}
                    >
                        {!loadedImages[currentSlide.imageUrl] && (
                            <Skeleton variant="rectangular" width="100%" height="100%" />
                        )}
                        <img
                            src={gifUrl + currentSlide.imageUrl}
                            alt={currentSlide.text}
                            onLoad={() => setLoadedImages((prev) => ({ ...prev, [currentSlide.imageUrl]: true }))}
                            style={{
                                width: '100%',
                                height: '100%',
                                display: loadedImages[currentSlide.imageUrl] ? 'block' : 'none',
                            }}
                        />
                    </Box>
                )}
                {currentSlide?.text && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '70%',
                            minHeight: '10vh'
                        }}
                    >
                        <p className={Styles.loadingMessage}>{currentSlide?.text}</p>
                    </Box>
                )}
                <Box
                    sx={{
                        width: '20rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <LinearProgress variant="determinate" value={progress} sx={{ minWidth: '95%' }} />
                    <Typography variant="body2" color="black" sx={{ marginLeft: 2 }}>
                        {`${progress}%`}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <p id="loadingText" className={Styles.loadingText}></p>
                </Box>
            </Box>

            {
                data.length > 1 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <KeyboardArrowRightIcon
                            onClick={handleForward}
                            fontSize="large"
                            sx={{ fontSize: '40px', cursor: 'pointer', color: 'rgb(0,0,0)' }}
                        />
                    </Box>
                )
            }
        </Backdrop >
    );
}

export default ContainerLoader;
